type Progress={runId?:string;sequence?:number;updatedAt?:number};
/** Sequence ordering applies only within one set; a new run starts its own phase/count. */
export function acceptsConceptProgress(current:Progress|undefined,incoming:Progress):boolean{
 if(current?.runId&&incoming.runId===current.runId&&typeof current.sequence==='number'&&typeof incoming.sequence==='number')return incoming.sequence>current.sequence;
 if(current?.runId&&incoming.runId&&current.runId!==incoming.runId){
  // Production run IDs are monotonically assigned angle-set primary keys.
  // A later set can reset its count; a late event from the previous set cannot.
  if(/^\d+$/.test(current.runId)&&/^\d+$/.test(incoming.runId))return BigInt(incoming.runId)>BigInt(current.runId);
  return true;
 }
 return !(typeof current?.updatedAt==='number'&&typeof incoming.updatedAt==='number'&&incoming.updatedAt<current.updatedAt);
}
